import { FC } from 'react';
import { useIntl } from 'react-intl';

import { usePathProps } from '../../modules/user-profile/hooks/usePathProps';
import { PageTitle } from '../../../_metronic/layout/core';
import { AlarmTable } from '../../modules/tasks';

const AlarmsPage: FC = () => {
  const intl = useIntl();
  usePathProps();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'alarms.title' })}
      </PageTitle>
      <AlarmTable />
    </>
  );
};

export { AlarmsPage };
